export enum PetType {
  CAT = "Cat",
  DOG = "Dog",
  RABBIT = "Rabbit",
  OTHER = "Other"
}